import { SectionTitle } from '../../../components/sectionTitle';
import { TextTile } from '../../../components/textTile';

import tireTracks from '../../../images/tire-track.png';

export interface IRozkladJazdyBgImageSectionProps {
    backgroundImage?: any;
}

export const RozkladJazdyBgImageSection = (props: IRozkladJazdyBgImageSectionProps) => {
    return <section className={`rozklad-jazdy-section-2`}>
        <div className="rozklad-jazdy-section-2__background" style={{backgroundImage: props.backgroundImage ? `url(${props.backgroundImage})` : ''}}>
            <div className="rozklad-jazdy-section-2__content-wrapper">
                <img src={tireTracks} alt="Ślady opon terenowych" className="rozklad-jazdy-section-2__tire-tracks" loading="lazy" />
                <img src={tireTracks} alt="Ślady opon terenowych" className="rozklad-jazdy-section-2__tire-tracks rozklad-jazdy-section-2__tire-tracks--second" loading="lazy" />

                <SectionTitle title={<>ROZKŁAD JAZDY <span className="text-color--primary">2025</span></>} customClassName={'section-title__wrapper--home'} />

                <div className="rozklad-jazdy-section-2__text-tiles-wrapper">
                    <div className="rozklad-jazdy-section-2__text-tiles-wrapper--pair">
                        <TextTile title={<SectionTitle title={<>ŚRODA – Dzień przyjazdu</>} />} subTitle={`18.06.2025`} customClassName={'text-tile__rozklad-jazdy'} 
                            text={<><p>od 14:00 – Przyjazd uczestników, rozpakowanie sprzętu, rejestracja</p><p>19:00-21:00 Kolacja integracyjna w formie bufetu szwedzkiego</p>
                                <p>21:00 – Odprawa organizacyjna i omówienie zasad jazdy</p></>} 
                        />

                        <TextTile title={<SectionTitle title={<>CZWARTEK – Rozgrzewka i parada ADV</>} />} subTitle={`19.06.2025`} customClassName={'text-tile__rozklad-jazdy'} 
                            text={<>
                                <p>07:00–09:00 – Śniadanie</p>
                                <p>09:00–12:00 – Przygotowanie sprzętu, serwis, tankowanie, ustawienia motocykli</p>
                                <p>12:00 – Zbiórka i formowanie kolumny</p>
                                <p>12:30 – Start parady motocykli ADV na rynek w Żywcu (ok. 200 motocykli)</p>
                                <p>13:00–15:00 – Postój na rynku: kawa, herbata, lody, lunch – pełna swoboda</p>
                                <p>15:00 – Przejazd grupowy na Krzyż na Grojcu – punkt widokowy, zdjęcia</p>
                                <p>ok. 17:00 – Powrót na ośrodek</p>
                                <p>17:30–19:00 – Motocyklowe konkursy i wyzwania na torze przeszkód</p>
                                <p>19:00–21:00 – Kolacja i wieczorna integracja</p>
                            </>} 
                        />
                    </div>

                    <TextTile title={<SectionTitle title={<>PIĄTEK – Główna trasa terenowa ADV</>} />} subTitle={`20.06.2025`} customClassName={'text-tile__rozklad-jazdy text-tile__rozklad-jazdy--mobile'} 
                        text={<>
                            <p>06:00–08:00 – Śniadanie</p>
                            <p>07:00–09:00 – Start tras terenowych (HARD / MEDIUM / EASY)</p>
                            <p>Grupy startują elastycznie w tym przedziale</p>
                            <p>Starty co 5 minut między grupami</p>
                            <p>Maksymalnie 6 osób w jednej grupie</p>
                            <p>Trasy o zróżnicowanym poziomie trudności, z punktami widokowymi i technicznymi sekcjami</p>
                            <p>18:00 – Obowiązkowy zjazd do asfaltu dla uczestników, którzy nie ukończyli trasy</p>
                            <p>19:00–21:00 – Kolacja i wieczorna integracja</p>
                        </>} 
                    />

                    <div className="rozklad-jazdy-section-2__text-tiles-wrapper--pair">
                        <TextTile title={<SectionTitle title={<>SOBOTA  – Nowe trasy ADV + Wielka impreza końcowa</>} />} subTitle={`21.06.2025`} customClassName={'text-tile__rozklad-jazdy'} 
                            text={<>
                                <p>06:00–08:00 – Śniadanie</p>
                                <p>07:00–09:00 – Start tras terenowych (HARD / MEDIUM / EASY)</p>
                                <p>Grupy startują elastycznie</p>
                                <p>Starty co 5 minut między grupami</p>
                                <p>Maksymalnie 6 osób w jednej grupie</p>
                                <p>Całkowicie nowe trasy względem piątku</p>
                                <p>18:00 – Obowiązkowy zjazd do asfaltu dla uczestników, którzy nie ukończyli trasy</p>
                                <p>19:00–21:00 – Kolacja gorąca</p>
                                <p>21:00–... – Wielka impreza końcowa:</p>
                                <p>Wręczenie nagród dla uczestników</p>
                                <p>Dodatkowa kolacja – zimna płyta i wszystko pod korek</p>
                                <p>Muzyka, integracja, zabawa do późna</p>
                            </>} 
                        />

                        <TextTile title={<SectionTitle title={<>NIEDZIELA</>} />} subTitle={`22.06.2025`} customClassName={'text-tile__rozklad-jazdy'} 
                            text={<><p>Wyjazd uczestników - wykwaterowanie do godziny 11.00</p></>} 
                        />
                    </div>
                </div>
                
                <TextTile title={<SectionTitle title={<>PIĄTEK – Główna trasa terenowa ADV</>} />} subTitle={`20.06.2025`} customClassName={'text-tile__rozklad-jazdy--desktop'} 
                    text={<>
                        <p>06:00–08:00 – Śniadanie</p>
                        <p>07:00–09:00 – Start tras terenowych (HARD / MEDIUM / EASY)</p>
                        <p>Grupy startują elastycznie w tym przedziale</p>
                        <p>Starty co 5 minut między grupami</p>
                        <p>Maksymalnie 6 osób w jednej grupie</p>
                        <p>Trasy o zróżnicowanym poziomie trudności, z punktami widokowymi i technicznymi sekcjami</p>
                        <p>18:00 – Obowiązkowy zjazd do asfaltu dla uczestników, którzy nie ukończyli trasy</p>
                        <p>19:00–21:00 – Kolacja i wieczorna integracja</p>
                    </>} 
                />
            </div>
        </div>
    </section>;
}